import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const SocialLinksThunk = createAsyncThunk(
	"socialLinks/SocialLinksThunk",
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const res = await axios.get(
				"https://api.msr7unaizah-com-606441.hostingersite.com/api/public/social_links"
			);

			return res?.data;
		} catch (error) {
			return rejectWithValue(error.response.data);
		}
	}
);
